export default __webpack_public_path__ + "static/media/mayor_book_header.1d786030.png";